<template>
  <v-btn :href="href" target="_blank" text rounded color="blue" v-bind="$attrs">
    <v-icon left>mdi-open-in-new</v-icon>
    <span>{{ label }}</span>
  </v-btn>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

const props = Vue.extend({
  props: {
    href: { type: String, required: true },
    label: { type: String, default: '' },
  },
});

@Component({ inheritAttrs: false })
export default class ExternalLink extends props {}
</script>
